import { COOKIE_BROADBAND_SEARCH } from '@/constants/cookies';
import { getBroadbandSearch } from '@/graphql/queries/broadband';
import lang from '@/lang/middleware/products/broadband';

export default async ({ $apolloQuery, app, $cookies, redirect, store }) => {
  const backToSearch = () => redirect(302, app.localePath('/compare-tv-broadband-phone/'));
  const code = $cookies.get(COOKIE_BROADBAND_SEARCH);
  if (!code) return backToSearch();
  await $apolloQuery(getBroadbandSearch, { code }).then(search => {
    store.$i18n.mergeLocaleMessage('en', lang.en);
    const title = store.$i18n.t('results.title');
    store.commit('search/set', search);
    store.commit('pageContent/setHead', { title });
  }).catch(_ => backToSearch());
};
